module.exports = __webpack_public_path__ + "img/company-updates-empty-image.84788d0f.webp";